import React from "react";
import { Link } from "react-router-dom";
import { fmtINR } from "@/lib/api";

export default function ProductCard({ p }) {
  const minPrice = Math.min(...(p.variants?.length ? p.variants.map((v) => v.price_inr) : [0]));
  return (
    <Link
      to={`/product/${p.id}`}
      data-testid={`product-card-${p.id}`}
      className="group relative flex flex-col border border-white/10 bg-zinc-950 hover:border-blue-500/60 transition-colors"
    >
      <div className="aspect-square overflow-hidden bg-zinc-900 border-b border-white/10">
        <img
          src={p.image_url}
          alt={p.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-4 flex flex-col gap-1.5">
        <div className="flex items-center justify-between">
          <span className="mono-label text-blue-400">{p.brand}</span>
          {p.featured && <span className="mono-label text-yellow-400">Featured</span>}
        </div>
        <h3 className="font-display text-base font-medium leading-snug line-clamp-2">{p.title}</h3>
        <p className="text-xs text-white/50 font-mono">{p.variants?.length || 0} variant{(p.variants?.length || 0) !== 1 ? "s" : ""}</p>
        <div className="mt-2 flex items-baseline justify-between">
          <div>
            <span className="text-xs text-white/50">From</span>
            <div className="font-mono text-lg text-white">{fmtINR(minPrice)}</div>
          </div>
          <span className="text-sm text-blue-400 group-hover:text-blue-300 transition-colors">View →</span>
        </div>
      </div>
    </Link>
  );
}
